import React from 'react';
import { createPlanNameMatcher } from '../utils/PlanMetaHelper';
import { IPlanContent } from '../../typings';
import { EverydayRewardsVariablePromoBox } from './EverydayRewardsVariablePromobox';
import {
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from '../common/planDefaults';
import { EmployeeInternetOfferPerk } from '../common/internetOfferPerk';

const PromoBox = <EverydayRewardsVariablePromoBox />;

export const employeeEverydayRewardsVariableContent: IPlanContent = {
  test: createPlanNameMatcher([
    'Origin Employee EDR Variable',
    'Origin Everyday Rewards Variable Plus',
  ]),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        gas: defaultKeyDetails,
        electricity: defaultKeyDetails,
        dual: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [EmployeeInternetOfferPerk],
        gas: [EmployeeInternetOfferPerk],
        electricity: [EmployeeInternetOfferPerk],
        defaultFuel: [],
      },
    },
    promoBox: {
      defaultState: {
        defaultFuel: PromoBox,
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'campaignOrange',
              odsCore: 'promoteC',
            },
            promobox: {
              styleGuide: 'campaignOrange',
              odsCore: 'promoteC',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'Collect Everyday Rewards points and watch points turn into dollars off your shopping!',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-everyday-rewards-variable/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
